"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TOUCH_TIMEOUT = exports.START_AUTO_CHANGE_DELAY = exports.SCROLLING_POINTER_MOVE_DISTANCE = exports.MAX_POINTER_MOVES_AFTER_TOUCH = exports.DEFAULT_STEP = exports.CHANGE_VALUE_TICK_DELAY = void 0;
const CHANGE_VALUE_TICK_DELAY = exports.CHANGE_VALUE_TICK_DELAY = 60;
const START_AUTO_CHANGE_DELAY = exports.START_AUTO_CHANGE_DELAY = 400;
const TOUCH_TIMEOUT = exports.TOUCH_TIMEOUT = 50;
const MAX_POINTER_MOVES_AFTER_TOUCH = exports.MAX_POINTER_MOVES_AFTER_TOUCH = 3;
const SCROLLING_POINTER_MOVE_DISTANCE = exports.SCROLLING_POINTER_MOVE_DISTANCE = 8;
const DEFAULT_STEP = exports.DEFAULT_STEP = 1;